import appLayout from '../layouts/AppLayout.vue'
export default [
  // USER
  {
    path: '/place/',
    name: 'place-list',
    component: () => import('../views/place/PlaceIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/place/create',
    name: 'place-create',
    component: () => import('../views/place/PlaceCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/place/:id',
    name: 'place-edit',
    component: () => import('../views/place/PlaceEdit.vue'),
    meta: { layout: appLayout }
  }
]
